import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function UsersIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M8.25 15a4.875 4.875 0 1 0 0-9.75 4.875 4.875 0 0 0 0 9.75Zm6.318-9.571a5.1 5.1 0 0 1 1.323-.178 4.875 4.875 0 1 1 0 9.75"
        stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M1.5 18.507a8.248 8.248 0 0 1 13.5 0M15.891 15a8.241 8.241 0 0 1 6.75 3.507" stroke="currentColor"
            strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </BaseIcon>
  );
}
